
import { addDays, compare, now, date as date_1, op_Subtraction, toString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { replace, join, concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { CategoryAvailabilityDto, AvailabilityStatus__ToI18nString, AvailabilityFactor__ToI18nString } from "../Shared/Availability.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { comparePrimitives, equals, int32ToString, createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { empty as empty_1, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ColoredDot } from "../Components/ColoredDot.js";
import { tryFind, choose, sortBy, isEmpty, filter, toArray, empty, singleton as singleton_1, append as append_1, map, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { useTranslation } from "react-i18next";
import { totalDays as totalDays_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/TimeSpan.js";
import { Gantt, GanttRow, GanttBarSegment } from "../Components/Gantt.js";
import { GanttColumn, GanttMarker } from "../Bindings/Feliz.ReactGantt.js";
import { Table } from "../Widgets/Table/Table.js";
import { ColumnDefinition$1, CellContent } from "../Widgets/Table/Types.js";
import { ResultViewMode, Msg } from "./Types.js";
import { TextButton, Button } from "../Components/Button.js";
import { ConfirmationDialog, Dialog } from "../Components/Dialog.js";
import { FormState__getValidation } from "../Shared/Shared.js";
import { ErrorAlert } from "../Components/Alert.js";
import { PositiveNumberInput, Input } from "../Components/Input.js";
import { defaultArg, unwrap, map as map_1 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Skeleton } from "../Components/Skeleton.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { MultiSelect } from "../Components/Select.js";
import { map as map_2 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { Hierarchy_getDisplayName } from "../Shared/Category.js";
import { DatePicker } from "../Components/DatePicker.js";

function formatDate(date) {
    return toString(date, "dd.MM.yyyy");
}

function formatPeriod(period) {
    return concat(formatDate(period.StartDate), " – ", ...formatDate(period.EndDate));
}

function formatBlock(t, block) {
    return `${t(AvailabilityFactor__ToI18nString(block.Factor))}${(block.Description === "") ? "" : concat(" (", block.Description, ...")")}: ${formatDate(block.StartDate)} – ${formatDate(block.EndDate)}`;
}

function SummaryTile(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("items-center"), delay(() => append(singleton("gap-2"), delay(() => append(singleton("rounded-lg"), delay(() => append(singleton("border"), delay(() => append(singleton("bg-white"), delay(() => append(singleton("px-4"), delay(() => append(singleton("py-3"), delay(() => append(singleton("cursor-pointer"), delay(() => append(singleton("select-none"), delay(() => (props.IsActive ? append(singleton("border-primary"), delay(() => append(singleton("ring-1"), delay(() => singleton("ring-primary"))))) : append(singleton("border-border"), delay(() => singleton("hover:border-primary")))))))))))))))))))))))))))], ["onClick", (_arg) => {
        props.OnClick();
    }], (elems = [createElement(ColoredDot, {
        Color: props.Color,
    }), reactElement("span", {
        className: join(" ", ["text-2xl", "font-semibold"]),
        children: int32ToString(props.Count),
    }), reactElement("span", {
        className: join(" ", ["text-sm"]),
        children: props.Label,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

const availableColorHex = "#50BF00";

function factorColorHex(factor) {
    switch (factor) {
        case "maintenance":
            return "#EBA44D";
        case "reservation":
            return "#9B6BEB";
        default:
            return "#4D9DEB";
    }
}

const availableColor = "bg-[#50BF00]";

function factorColor(factor) {
    switch (factor) {
        case "maintenance":
            return "bg-[#EBA44D]";
        case "reservation":
            return "bg-[#9B6BEB]";
        default:
            return "bg-[#4D9DEB]";
    }
}

function ToolNameCell(props) {
    return reactElement("span", {
        className: join(" ", ["text-primary-link", "cursor-pointer", "hover:underline", "truncate"]),
        title: props.row.text,
        children: props.row.text,
        onClick: (_arg) => {
            RouterModule_nav(ofArray(["tools", props.row.id]), 1, 1);
        },
    });
}

function LegendEntry(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-1.5"])], (elems = [reactElement("div", {
        className: join(" ", ["w-3", "h-3", "rounded-sm", props.ColorClass]),
    }), reactElement("span", {
        className: join(" ", ["text-xs"]),
        children: props.Label,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function AvailabilityTimeline(props) {
    let elems_1, elems;
    const t = useTranslation()[0];
    const startDate = props.Availability.StartDate;
    const endDate = props.Availability.EndDate;
    const totalDays = totalDays_1(op_Subtraction(date_1(endDate), date_1(startDate))) + 1;
    const toSegment = (colorHex, label, segmentStart, segmentEnd) => (new GanttBarSegment((totalDays_1(op_Subtraction(date_1(segmentStart), date_1(startDate))) / totalDays) * 100, ((totalDays_1(op_Subtraction(date_1(segmentEnd), date_1(segmentStart))) + 1) / totalDays) * 100, colorHex, label));
    const rows = map((tool) => (new GanttRow(tool.ToolId, tool.DisplayName, append_1(map((period) => toSegment(availableColorHex, concat(t("availability.status_available"), ": ", ...formatPeriod(period)), period.StartDate, period.EndDate), tool.AvailablePeriods), map((block) => toSegment(factorColorHex(block.Factor), formatBlock(t, block), block.StartDate, block.EndDate), tool.Blocks)))), props.Availability.Tools);
    let markers;
    const today = date_1(now());
    markers = (((compare(today, date_1(startDate)) >= 0) && (compare(today, date_1(endDate)) <= 0)) ? singleton_1(new GanttMarker(today, t("availability.today"), "availability-today-marker")) : empty());
    const columns = singleton_1(new GanttColumn("text", t("general.tool"), 1, (props_1) => createElement(ToolNameCell, props_1)));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2", "rounded-lg", "border", "border-border", "bg-white", "p-4"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-4", "mb-1"])], (elems = [createElement(LegendEntry, {
        ColorClass: availableColor,
        Label: t("availability.status_available"),
    }), createElement(LegendEntry, {
        ColorClass: factorColor("assignment"),
        Label: t("availability.factor_assignment"),
    }), createElement(LegendEntry, {
        ColorClass: factorColor("maintenance"),
        Label: t("availability.factor_maintenance"),
    }), createElement(LegendEntry, {
        ColorClass: factorColor("reservation"),
        Label: t("availability.factor_reservation"),
    }), createElement(LegendEntry, {
        ColorClass: "bg-red",
        Label: t("availability.today"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(Gantt, {
        Columns: columns,
        EndDate: addDays(endDate, 1),
        Markers: markers,
        Rows: rows,
        StartDate: startDate,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function AvailabilityTable(props) {
    let TableRows;
    const t = useTranslation()[0];
    return createElement(Table, (TableRows = toArray(props.Availability.Tools), {
        ColumnDefinitions: [new ColumnDefinition$1("status", "", t("availability.status"), (row) => (new CellContent(0, [t(AvailabilityStatus__ToI18nString(row.Status))])), "select", "text"), new ColumnDefinition$1("displayName", "", t("general.tool"), (row_1) => (new CellContent(3, [row_1.DisplayName, () => {
            RouterModule_nav(ofArray(["tools", row_1.ToolId]), 1, 1);
        }])), "text", "button"), new ColumnDefinition$1("inventoryNumber", "", t("tool.inventory_number"), (row_2) => (new CellContent(0, [row_2.InventoryNumber])), "text", "text"), new ColumnDefinition$1("storage", "", t("general.storage"), (row_3) => (new CellContent(0, [row_3.StorageName])), "select", "text"), new ColumnDefinition$1("availableDays", "", t("availability.available_days"), (row_4) => (new CellContent(0, [replace(replace(t("availability.days_of_days"), "{{available}}", int32ToString(row_4.AvailableDays)), "{{total}}", int32ToString(row_4.TotalDays))])), "text", "text"), new ColumnDefinition$1("availablePeriods", "", t("availability.available_periods"), (row_5) => (new CellContent(0, [join(", ", map(formatPeriod, row_5.AvailablePeriods))])), "text", "text"), new ColumnDefinition$1("blocks", "", t("availability.blocks"), (row_6) => (new CellContent(0, [join(", ", map((block) => formatBlock(t, block), row_6.Blocks))])), "text", "text")],
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["displayName", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "category-availability-table",
        TableRows: TableRows,
    }));
}

function AvailabilityResult(props) {
    let elems_2;
    const t = useTranslation()[0];
    let filteredAvailability;
    const matchValue = props.StatusFilter;
    if (matchValue == null) {
        filteredAvailability = props.Availability;
    }
    else {
        const status = matchValue;
        const bind$0040 = props.Availability;
        filteredAvailability = (new CategoryAvailabilityDto(bind$0040.Categories, bind$0040.StartDate, bind$0040.EndDate, filter((tool) => (tool.Status === status), props.Availability.Tools), bind$0040.AvailableCount, bind$0040.PartiallyAvailableCount, bind$0040.UnavailableCount));
    }
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_2 = toList(delay(() => {
        let elems, Label, Label_1, Label_2;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-3"])], (elems = [createElement(SummaryTile, (Label = t("availability.status_available"), {
            Color: "green",
            Count: props.Availability.AvailableCount,
            IsActive: equals(props.StatusFilter, "available"),
            Label: Label,
            OnClick: () => {
                props.Dispatch(new Msg(8, ["available"]));
            },
        })), createElement(SummaryTile, (Label_1 = t("availability.status_partially_available"), {
            Color: "orange",
            Count: props.Availability.PartiallyAvailableCount,
            IsActive: equals(props.StatusFilter, "partiallyAvailable"),
            Label: Label_1,
            OnClick: () => {
                props.Dispatch(new Msg(8, ["partiallyAvailable"]));
            },
        })), createElement(SummaryTile, (Label_2 = t("availability.status_unavailable"), {
            Color: "red",
            Count: props.Availability.UnavailableCount,
            IsActive: equals(props.StatusFilter, "unavailable"),
            Label: Label_2,
            OnClick: () => {
                props.Dispatch(new Msg(8, ["unavailable"]));
            },
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-2"])], (elems_1 = [createElement(Button, {
                ComponentState: "enabled",
                Label: t("availability.view_timeline"),
                OnClick: () => {
                    props.Dispatch(new Msg(7, [new ResultViewMode(0, [])]));
                },
                TestId: "availability-view-timeline-test-id",
                Variant: (props.ViewMode.tag === 1) ? "secondary" : "primary",
            }), createElement(Button, {
                ComponentState: "enabled",
                Label: t("availability.view_table"),
                OnClick: () => {
                    props.Dispatch(new Msg(7, [new ResultViewMode(1, [])]));
                },
                TestId: "availability-view-table-test-id",
                Variant: (props.ViewMode.tag === 0) ? "secondary" : "primary",
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => (isEmpty(filteredAvailability.Tools) ? singleton(reactElement("div", {
                className: join(" ", ["text-sm", "text-text-muted"]),
                children: t("availability.no_tools_for_status"),
            })) : ((props.ViewMode.tag === 1) ? singleton(createElement(AvailabilityTable, {
                Availability: filteredAvailability,
            })) : singleton(createElement(AvailabilityTimeline, {
                Availability: filteredAvailability,
            }))))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function SaveViewDialog(props) {
    let Title, elems, Label_3, matchValue_1, periodDays_1;
    const t = useTranslation()[0];
    const state = props.State;
    const dispatch = props.Dispatch;
    const componentState = state.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(Dialog, (Title = t("availability.save_view_title"), {
        Body: singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems = toList(delay(() => {
            let matchValue;
            return append((matchValue = FormState__getValidation(state.FormState, t, "global"), (matchValue == null) ? (empty_1()) : singleton(createElement(ErrorAlert, {
                Label: matchValue,
            }))), delay(() => append(singleton(reactElement("div", {
                className: join(" ", ["text-sm", "text-text-muted"]),
                children: t("availability.save_view_hint"),
            })), delay(() => append(singleton(createElement(Input, {
                ComponentState: componentState,
                Label: t("availability.save_view_name"),
                OnChange: (arg) => {
                    dispatch(new Msg(14, [arg]));
                },
                TestId: "availability-save-view-name-test-id",
                Value: state.SaveViewName,
            })), delay(() => singleton(createElement(PositiveNumberInput, {
                ComponentState: componentState,
                Label: t("availability.save_view_period_days"),
                MaxValue: 365,
                OnChange: (value_5) => {
                    dispatch(new Msg(15, [map_1((value_6) => (~~value_6 | 0), value_5)]));
                },
                TestId: "availability-save-view-period-days-test-id",
                Value: unwrap(map_1((value_4) => value_4, state.SaveViewPeriodDays)),
            }))))))));
        })), ["children", reactApi.Children.toArray(Array.from(elems))])])))),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: () => {
                dispatch(new Msg(11, []));
            },
            TestId: "availability-save-view-cancel-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, (Label_3 = t("general.save"), {
            ComponentState: (matchValue_1 = state.SaveViewPeriodDays, (matchValue_1 != null) ? ((((matchValue_1 >= 1) && (state.SaveViewName.trim() !== "")) && !state.FormState.IsLoading) ? ((periodDays_1 = (matchValue_1 | 0), "enabled")) : "disabled") : "disabled"),
            Label: Label_3,
            OnClick: () => {
                dispatch(new Msg(16, []));
            },
            TestId: "availability-save-view-confirm-test-id",
            Variant: "blueButton",
        }))]),
        IsOpen: state.SaveDialogIsOpen,
        OnClose: () => {
            dispatch(new Msg(11, []));
        },
        Title: Title,
    }));
}

function ManageViewsDialog(props) {
    let Title, elems_2, Title_1;
    const t = useTranslation()[0];
    const state = props.State;
    const dispatch = props.Dispatch;
    const componentState = state.FormState.IsLoading ? "disabled" : "enabled";
    const xs_6 = [createElement(Dialog, (Title = t("availability.saved_views"), {
        Body: singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_2 = toList(delay(() => {
            let matchValue;
            return append((matchValue = FormState__getValidation(state.FormState, t, "global"), (matchValue == null) ? (empty_1()) : singleton(createElement(ErrorAlert, {
                Label: matchValue,
            }))), delay(() => {
                const matchValue_1 = state.SavedViews;
                return (matchValue_1.tag === 1) ? (isEmpty(matchValue_1.fields[0]) ? singleton(reactElement("div", {
                    className: join(" ", ["text-sm", "text-text-muted"]),
                    children: t("availability.no_saved_views"),
                })) : map((savedView) => {
                    let elems_1, elems;
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-between", "gap-4", "border-b", "border-border", "pb-2"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems = [reactElement("span", {
                        className: join(" ", ["text-sm"]),
                        children: savedView.Name,
                    }), reactElement("span", {
                        className: join(" ", ["text-xs", "text-text-muted"]),
                        children: replace(t("availability.period_next_days"), "{{days}}", int32ToString(savedView.PeriodDays)),
                    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(TextButton, {
                        ComponentState: componentState,
                        Label: t("general.delete"),
                        OnClick: () => {
                            dispatch(new Msg(17, [savedView.Name]));
                        },
                        TestId: "availability-delete-view-test-id",
                        Variant: "blueButton",
                    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
                }, matchValue_1.fields[0])) : singleton(createElement(Skeleton, {
                    Variant: "detail",
                }));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))),
        Controls: singleton_1(createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.close"),
            OnClick: () => {
                dispatch(new Msg(13, []));
            },
            TestId: "availability-manage-views-close-test-id",
            Variant: "blueButton",
        })),
        IsOpen: state.ManageDialogIsOpen,
        OnClose: () => {
            dispatch(new Msg(13, []));
        },
        Title: Title,
    })), createElement(ConfirmationDialog, (Title_1 = t("availability.delete_view_title"), {
        Description: replace(t("availability.delete_view_confirmation"), "{{name}}", defaultArg(state.ViewToDelete, "")),
        FormState: state.FormState,
        IsOpen: state.ViewToDelete != null,
        OnClose: () => {
            dispatch(new Msg(18, []));
        },
        OnConfirm: () => {
            dispatch(new Msg(19, []));
        },
        Title: Title_1,
    }))];
    return react.createElement(react.Fragment, {}, ...xs_6);
}

export function AvailabilityView(props) {
    let elems_2;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1(props.ViewName, undefined), update_1, (_arg, _arg_1) => {
    }), undefined, [props.ViewName]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_2 = toList(delay(() => {
        let elems, Label_3, matchValue_1;
        const matchValue = state_1.Categories;
        if (matchValue.tag === 1) {
            const categories = matchValue.fields[0];
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-1", "md:grid-cols-4", "gap-4", "items-end"])], (elems = [createElement(MultiSelect, {
                ComponentState: componentState,
                IsClearable: true,
                Label: t("availability.categories"),
                NoOptionsMessage: "availability.no_categories",
                OnChange: (options) => {
                    dispatch(new Msg(1, [defaultArg(map_1((options_1) => ofArray(map_2((_arg_3) => _arg_3.value, options_1)), options), empty())]));
                },
                Options: sortBy((_arg_2) => _arg_2.label, map((category) => ({
                    label: Hierarchy_getDisplayName(categories, category),
                    value: category.Id,
                }), categories), {
                    Compare: (x, y) => (comparePrimitives(x, y) | 0),
                }),
                PlaceholderKey: "availability.select_categories",
                TestId: "availability-category-select-test-id",
                Value: map((category_2) => ({
                    label: Hierarchy_getDisplayName(categories, category_2),
                    value: category_2.Id,
                }), choose((categoryId) => tryFind((category_1) => equals(category_1.Id, categoryId), categories), state_1.SelectedCategoryIds)),
            }), createElement(DatePicker, {
                ComponentState: componentState,
                IsClearable: true,
                Label: t("availability.start_date"),
                MaxDate: unwrap(state_1.EndDate),
                OnChange: (arg) => {
                    dispatch(new Msg(2, [arg]));
                },
                TestId: "availability-start-date-test-id",
                Value: unwrap(state_1.StartDate),
            }), createElement(DatePicker, {
                ComponentState: componentState,
                IsClearable: true,
                Label: t("availability.end_date"),
                MinDate: unwrap(state_1.StartDate),
                OnChange: (arg_1) => {
                    dispatch(new Msg(3, [arg_1]));
                },
                TestId: "availability-end-date-test-id",
                Value: unwrap(state_1.EndDate),
            }), createElement(Button, (Label_3 = t("availability.check"), {
                ComponentState: (matchValue_1 = state_1.SelectedCategoryIds, (state_1.StartDate != null) ? ((state_1.EndDate != null) ? ((!isEmpty(matchValue_1) && !state_1.FormState.IsLoading) ? "enabled" : "disabled") : "disabled") : "disabled"),
                Label: Label_3,
                OnClick: () => {
                    dispatch(new Msg(5, []));
                },
                TestId: "availability-check-test-id",
                Variant: "primary",
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                let elems_1;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "items-center", "gap-2"])], (elems_1 = toList(delay(() => append(map((days) => createElement(Button, {
                    ComponentState: componentState,
                    Label: replace(t("availability.period_next_days"), "{{days}}", int32ToString(days)),
                    OnClick: () => {
                        dispatch(new Msg(4, [days]));
                    },
                    TestId: `availability-period-preset-${days}-test-id`,
                    Variant: equals(state_1.SelectedPeriodDays, days) ? "primary" : "secondary",
                }), ofArray([7, 14, 30])), delay(() => append(singleton(reactElement("div", {
                    className: join(" ", ["grow"]),
                })), delay(() => append(singleton(createElement(Button, {
                    ComponentState: "enabled",
                    Label: t("availability.saved_views"),
                    OnClick: () => {
                        dispatch(new Msg(12, []));
                    },
                    TestId: "availability-manage-views-test-id",
                    Variant: "secondary",
                })), delay(() => {
                    let Label_6;
                    return singleton(createElement(Button, (Label_6 = t("availability.save_view"), {
                        ComponentState: (state_1.StartDate != null) ? ((state_1.EndDate != null) ? ((!isEmpty(state_1.SelectedCategoryIds) && !state_1.FormState.IsLoading) ? "enabled" : "disabled") : "disabled") : "disabled",
                        Label: Label_6,
                        OnClick: () => {
                            dispatch(new Msg(10, []));
                        },
                        TestId: "availability-save-view-test-id",
                        Variant: "secondary",
                    })));
                })))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => append(singleton(createElement(SaveViewDialog, {
                    Dispatch: dispatch,
                    State: state_1,
                })), delay(() => append(singleton(createElement(ManageViewsDialog, {
                    Dispatch: dispatch,
                    State: state_1,
                })), delay(() => {
                    if (state_1.FormState.IsLoading) {
                        return singleton(createElement(Skeleton, {
                            Variant: "table",
                        }));
                    }
                    else {
                        const matchValue_8 = state_1.Availability;
                        if (matchValue_8 == null) {
                            return singleton(reactElement("div", {
                                className: join(" ", ["text-sm", "text-text-muted"]),
                                children: t("availability.select_hint"),
                            }));
                        }
                        else {
                            const availability = matchValue_8;
                            return append(singleton(reactElement("div", {
                                className: join(" ", ["text-sm", "text-text-muted"]),
                                children: replace(replace(replace(t("availability.result_title"), "{{category}}", join(", ", map((_arg_8) => _arg_8.CategoryName, availability.Categories))), "{{startDate}}", formatDate(availability.StartDate)), "{{endDate}}", formatDate(availability.EndDate)),
                            })), delay(() => (isEmpty(availability.Tools) ? singleton(reactElement("div", {
                                className: join(" ", ["text-sm"]),
                                children: t("availability.no_tools_in_selection"),
                            })) : singleton(createElement(AvailabilityResult, {
                                Availability: availability,
                                Dispatch: dispatch,
                                StatusFilter: unwrap(state_1.StatusFilter),
                                ViewMode: state_1.ViewMode,
                            })))));
                        }
                    }
                }))))));
            }));
        }
        else {
            return singleton(createElement(Skeleton, {
                Variant: "table",
            }));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

